module.exports = __webpack_public_path__ + "img/f2285777fed142e3bcbcf111dd133f01.png";